module.exports = __webpack_public_path__ + "static/img/图层 21.832ee73b.png";